<template>
	<Layout>
		<div class="rwt-portfolio-area rn-section-gap">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<!-- Start 标题 -->
						<SectionTitle
						    text-align="center"
						    subtitle="Products Gallery"
						    title="产 品 中 心"
						    data-aos="fade-up"
						/>
						<!-- end 标题 -->
						
						<div class="rn-blog-area rn-section-gap">
							<div class="container">
								<div class="row row--30">
									<!-- Start 左侧导航 -->
									<div class="col-lg-3 mt_md--40 mt_sm--40">
										<div class="rbt-single-widget widget_categories mt--40">
										    <h3 class="title">产品类型</h3>
										    <div class="inner">
										        <div class="category-list">
										        	<aside>
										        		<ul>
										        			<li v-for="(item,index) in menuList" :key="index" style="padding-bottom: 5px;">
										        				<div :class={activeNav:item.isSelected} @click="showToggle(item,index)" style="display: flex;justify-content: space-between;">
										        					<span class="left-content">{{ item.name }}</span>
										        					<span class="count-text" v-if="item.subItems.length > 0">{{ item.subItems.length }}</span>
										        				</div>
										        				<!-- start 次级菜单 -->
										        				<ul v-show="item.isSubShow">
										        					<li v-for="(subItem,subIndex) in item.subItems" :key="subIndex" style="padding-bottom: 5px;">
										        						<div :class={activeNav:subItem.isSelected} @click="showToggle(subItem,subIndex)">			
										        							<span style="margin-left: 20px;">{{subItem.name}}</span>
										        						</div>
										        					</li>
										        				</ul>
										        				<!-- end 次级菜单 -->
										        			</li>
										        		</ul>
										        	</aside>
										        </div>
										    </div>
										</div>									    
									</div>
									<!-- end 左侧导航 -->
									
									<!-- Start 右侧列表显示 -->
									<div class="col-lg-9">
										<div class="row mt_dec--30">
											<div class="col-lg-12">
												<div class="col-lg-12  mt--30"
													data-aos="slide-up"
													data-aos-duration="800">
													<!-- <BlogPost :products-intro="edgeProductsIntro" :products-intro-key="edgeProductsIntroKey" blog-post-style="2"/> -->
													<div class="rn-card box-card-style-default edge-card-list-view">
														<div class="inner">
															<div class="onlycontent">
																<el-table :data="edgeProductsIntro" :key="edgeProductsIntroKey" border style="width: 100%;margin: 0 0;" :header-cell-style="headClass" @cell-click="clickSell">
																	<el-table-column prop="qrCode" label="产品" min-width="25%">
																		<template slot-scope="scope">
																			<img class="w-100" :src="scope.row.thumbnail" >
																		</template>
																	</el-table-column>
																	<el-table-column label="型号" min-width="15%">
																		<template slot-scope="scope">
																			<span v-html="scope.row.PTName"></span>
																		</template>
																	</el-table-column>
																	<el-table-column label="资源" min-width="30%">
																		<template slot-scope="scope">
																			<span v-html="scope.row.Resource"></span>
																		</template>
																	</el-table-column>
																	<el-table-column label="简介" min-width="30%">
																		<template slot-scope="scope">
																			<span v-html="scope.row.Intro"></span>
																		</template>
																	</el-table-column>
																</el-table>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<!-- end 右侧列表显示 -->
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
	import Layout from '../components/common/Layout'
	import SectionTitle from "../components/elements/sectionTitle/SectionTitle"
	import BlogSidebar from '../components/blog/BlogSidebar'
	import BlogPost from '../components/blog/BlogPost'
	import BlogPostMixin from '../mixins/BlogPostMixin'
	
	export default {
		name:'EdgeProductsPage',
		components:{
			Layout,SectionTitle,BlogSidebar,BlogPost
		},
		mixins: [BlogPostMixin],
		data(){
			return{
				// edgeProductsIntro:[]
				selectItem:{
					categoryID:'',
            		typeName:''
				}
			}			
		},
		methods:{
			headClass() {
			  //表头居中显示
			  return "text-align:center ;background-color:#d0f0fc;";
			},
			flush: function() {
				this.$router.go(0);
			},
			// 点击展开折叠菜单事件
			showToggle: function(item, ind) {
				
				if(item.slug != 0){
					this.selectItem.categoryID = item.slug
				}				

				this.menuList.forEach(i => {
					i.isSelected = false;
					if(i.subItems.length>0){
						i.subItems.forEach(j => {
							j.isSelected = false;
						});
					}
				});

				if(item.subItems == undefined || item.subItems.length <= 0){
					this.getCategoriesData(item.slug);
					item.isSelected = true;
					return;
				}
				else{					
					item.isSelected = true;
				}

				this.menuList.forEach(i => {
					// 判断如果数据中的menuList[i]的show属性不等于当前数据的isSubShow属性那么menuList[i]等于false
					if (i.isSubShow !== this.menuList[ind].isSubShow) {
						i.isSubShow = false;						
					}
				});

				item.isSubShow = !item.isSubShow;
			},
			clickRow (row) {

				/* 本来这里是点击行内所有位置都会跳转@row-click，后来感觉不太方便，就改成只有点击图片才会跳转@cell-click */
				this.selectItem.typeName = row.PTName;

				this.$store.state.productBread = this.selectItem;
			    this.$router.push("/product-detail/" +row.id);
			},
			clickSell (row, column) {

				this.selectItem.typeName = row.PTName;
				this.$store.state.productBread = this.selectItem;

				if(column.label == "产品" || column.label == "型号"){
					this.$router.push("/product-detail/" +row.id);
				}
			},
			HighLightSelectItem (slug){

				this.menuList.forEach(i => {

					if(i.slug == slug){
						i.isSelected = true;
						return;					
					}

					if(i.subItems.length>0){
						i.subItems.forEach(j => {
							if(j.slug == slug){
								i.isSubShow = true;
								j.isSelected = true;
								return;					
							}
						});
					}
				});
			}		
		},/* end methods */	
		watch:{
			'$route': {
				handler:function(){
					// this.$router.go(0);
					this.getCategoriesData(this.$route.params.categoryID)
				},
				immediate:true,
				// deep:true,
			}
		},
		beforeRouteEnter (to, from, next) {
			
		    // console.log(`beforeRouteEnter - ${to.path},${to.params.categoryID},${to.path.substring(1,to.path.lastIndexOf('/'))}`);
			
		    		
		    next(obj=>{

				// 这里如果在next外部是无效的，即：this.$store.state.productBread.categoryID，会报错this.$store undefined
				// console.log(`obj.$store.state.productBread.categoryID - ${obj.$store.state.productBread.categoryID}`);

				let categoryID = obj.$store.state.productBread.categoryID;
				if(categoryID != null && categoryID != undefined && categoryID != ""){
					obj.selectItem = {
						categoryID:categoryID,
						typeName:obj.$store.state.productBread.typeName
					}
				}
				else{
					categoryID = to.params.categoryID;
				}

				// console.log(`obj.$store.state.productBread.categoryID - ${obj.$store.state.productBread.categoryID}`);
				// console.log(`to.params.categoryID - ${to.params.categoryID}`);
				// console.log(`categoryID - ${categoryID}`);
				

		    	if(to.path.substring(1,to.path.lastIndexOf('/')) == 'products'){
		    		obj.getCategoriesData(categoryID);
		    		obj.HighLightSelectItem(categoryID);
		    	}
		    });
		},
		// beforeRouteUpdate (to, from, next) {
			  
		// 	console.log(`beforeRouteUpdate - to.path=${to.path},to.params.categoryID=${to.params.categoryID},${to.path.substring(1,to.path.lastIndexOf('/'))}`);
		// 	this.getCategoriesData(to.params.categoryID);
		// 	this.edgeProductsIntroKey = to.params.categoryID;
		// 	console.log(this.edgeProductsIntroKey);
			
		// 	next(obj=>{
		// 		console.log("to.path.substring(1,to.path.lastIndexOf('/')="+to.path.substring(1,to.path.lastIndexOf('/')));
				
		// 		if(to.path.substring(1,to.path.lastIndexOf('/')) == 'products'){
		// 			this.getCategoriesData(to.params.categoryID);
		// 			console.log(getCategoriesData);
		// 		}
		// 	});
		// }
	}
</script>

<style>	
	table {
		margin: 0 0 !important;
		font-size: 18px;
	}
	.activeNav span{
		/* background: rgb(84, 92, 100) !important; */
		color:rgb(255, 208, 175) !important;
	}
</style>